/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Notifications_Expiration_LabelInputs */

const he_notifications_expiration_label = /** @type {(inputs: Notifications_Expiration_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`זמן סיום ההתראות`)
};

const en_notifications_expiration_label = /** @type {(inputs: Notifications_Expiration_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notification Duration`)
};

/**
* | output |
* | --- |
* | "Notification Duration" |
*
* @param {Notifications_Expiration_LabelInputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
export const notifications_expiration_label = /** @type {((inputs?: Notifications_Expiration_LabelInputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notifications_Expiration_LabelInputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_notifications_expiration_label(inputs)
	return en_notifications_expiration_label(inputs)
});